import React from "react";
import ProductListPage from "../../../../components/List/ProductListPage";

const OrganizationProductIndexIndexPage = () => {
	return <ProductListPage productType="BASIC" />;
};

export default OrganizationProductIndexIndexPage;
